import { FC, ReactNode } from 'react';

import { Accordion, Title, useBreakpoint } from '@hh.ru/magritte-ui';

interface Props {
    title: string;
    onClick?: () => void;
    children: ReactNode;
}

const FAQItem: FC<Props> = ({ title, onClick, children }) => {
    const { isMobile } = useBreakpoint();

    return (
        <Accordion
            borderRadius={isMobile ? 16 : 24}
            padding={isMobile ? 16 : 24}
            stretched
            onClick={onClick}
            title={
                <Title Element="h3" size="small">
                    {title}
                </Title>
            }
        >
            {children}
        </Accordion>
    );
};

export default FAQItem;
